import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';

export default function BackSection({ pageName, to }) {
  return (
    <div className='d-flex text-white align-content-center '>
      <NavLink to={to}>
        <i className="fa-solid fa-angle-left mt-1 text-dark"></i>
      </NavLink>
      <p className="my-0 p-0 ms-3 text-dark">{pageName}</p>
    </div>
  )
}
